import { Tag, Text } from "@zapier/design-system";
import styles from "./DraftBanner.module.css";
import { sideBarWidthAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
interface DraftBannerProps {
  message?: string;
}

export const DraftBanner: React.FC<DraftBannerProps> = ({
  message = "You're previewing a draft. Creating it will generate the assets in your Zapier account.",
}) => {
  const sideBarWidth = useAtomValue(sideBarWidthAtom);

  const dynamicStyles = {
    "--left": `${sideBarWidth}px`,
  };

  return (
    <div
      className={styles.wrapper}
      style={dynamicStyles as React.CSSProperties}
    >
      <Tag size="small" variant="warning">
        Draft
      </Tag>
      <div>
        <Text color="TextWeaker" type="Body1Multiline">
          {message}
        </Text>
      </div>
    </div>
  );
};

export default DraftBanner;
